import api from "./api";

export const getAuthRequests = (page, params) => {
  return api.get("admin/AuthRequest", { params: { page: page, limit: 10, ...params } });
};

export const getAuthRequestsBySearch = (searchItem, search) => {
  return api.get(`admin/AuthRequest?searchItem=${searchItem}&search=${search}`);
};

export const getAuthRequestsByOrder = (item, direction) => {
  return api.get(`admin/AuthRequest?order=${item}&direction=${direction}`);
};

export const invalidatedAuth = (id) => { 
  return api.post(`admin/invalidateRequest/update/${id}`);
}

